<template>
	<div>
		<div class="main">
			<BaseCheckbox :label="$store.getters.getDamageCaseRepairShopLabel + ' ' + $t('store')" v-model="repairShopDesired" class="mb-5" />
			<CompanyForm
				v-if="repairShopDesired"
				:options="options"
				:options-label="$store.getters.getDamageCaseRepairShopLabel"
				v-model="model.repairShop"
				:custom-label="$t('foreign_company').toString()"
			/>
		</div>
		<div class="flex justify-end">
			<BaseButton @click="save" class="mb-4 btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import { DamagecasesApiFactory, RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import CompanyForm from '@/components/damagecases/forms/CompanyForm';
import stateMerge from 'vue-object-merge';
import { makeShadowCopy } from '@/plugins/Utils';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';

export default {
	name: 'RepairShop',
	components: { BaseCheckbox, CompanyForm, BaseButton },
	data() {
		return {
			repairShopDesired: true,
			model: {
				city: {
					zipCode: null,
					name: null,
				},
			},
			options: [],
		};
	},
	methods: {
		updateDamageCaseStore() {
			this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) });
		},
		getDamageCaseFromApi: function() {
			this.$store.dispatch('updateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) }).then(() => {
				stateMerge(this.model, this.$store.getters.getDamageCase);
				//this.repairShopDesired = this.model.repairShop !== undefined;
				this.model = makeShadowCopy(this.model);
			});
		},
		save() {
			const isCustomCompany = this.model.repairShop.isEditable && this.model.repairShop.id;
			this.$store.commit('setConfirmLeaving', false);
			if (!this.repairShopDesired) {
				this.updateDamagecase(true).then(result => {
					this.updateDamageCaseStore();
				});
			} else if (this.model._shadow?.repairShop?.id !== this.model.repairShop.id) {
				this.updateDamagecase(!isCustomCompany).then(result => {
					if (isCustomCompany) {
						this.updateRepairShop().then(this.updateDamageCaseStore);
					} else {
						this.updateDamageCaseStore();
					}
				});
			} else if (isCustomCompany) {
				this.updateRepairShop().then(this.updateDamageCaseStore);
			}
		},
		updateRepairShop() {
			return RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.repairshopsIdPut(this.model.repairShop.id, this.model.repairShop)
				.then(response => {
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('company_saved').toString(),
						icon: 'success',
					}).then(result => {
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		updateDamagecase(showMessageBox) {
			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdRepairShopPut(
					parseInt(this.$route.params.processId || this.$route.params.id),
					this.repairShopDesired ? this.model.repairShop : null,
				)
				.then(response => {
					if (showMessageBox) {
						this.$swal({
							title: this.$t('general.success').toString(),
							text: this.$t('assigned_company_damage_case').toString(),
							icon: 'success',
						}).then(result => {
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
							});
						});
					}
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
	},
	mounted() {
		this.getDamageCaseFromApi();

		RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
			.repairshopsGet(2)
			.then(res => {
				this.options = res.data;
			})
			.catch(error => {
				this.$swal(this.$t('general.attention').toString(), this.$t('no_companies_found').toString(), 'warning');
			});
	},
};
</script>

<style scoped></style>
